import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Grid, Button } from '@mui/material';
import UploadField from '../../Common/UploadField';
import FullScreenLoader from '../Loader/FullScreenLoader';
import { postRequest } from '../interceptor/interceptor';
import { ADD_IMAGE } from '../../apiConst';
import { useNavigate } from 'react-router';
import { toast } from 'react-toastify';
import { imageFields } from '../../Fields/imageFields';

const AddImage = ({ getListData }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [imageFile, setImageFile] = useState(null);
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({});

  const onSubmit = async (data) => {
    if (!imageFile) {
      toast.error('Please upload an image.');
      return;
    }

    setIsLoading(true);
    const formData = new FormData();
    formData.append('file', imageFile);
    formData.append('isPublic', true);

    try {
      const response = await postRequest(ADD_IMAGE, formData, {
        'Content-Type': 'multipart/form-data',
      });
      toast.success('Image uploaded successfully!');
      getListData();
      reset();
      setImageFile(null);
    } catch (error) {
      toast.error('Failed to upload image.');
    } finally {
      setIsLoading(false);
    }
  };

  const onCancel = () => {
    reset();
    setImageFile(null);
  };

  return (
    <>
      {isLoading && <FullScreenLoader />}
      <div className="block rounded-lg bg-white p-8 shadow-md m-2 overflow-auto">
        <div className="flex items-center mb-4 text-2xl font-bold text-gray-800">
          Add Image
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={3} alignItems="center">
            {imageFields.map(({ fieldTitle, fieldName, validationObj }) => (
              <Grid item xs={12} lg={4} key={fieldName}>
                <div className="flex flex-col">
                  <label className="text-gray-800 text-sm font-semibold mb-2">
                    {fieldTitle}
                  </label>
                  <UploadField
                    fieldName={fieldName}
                    validationObj={validationObj}
                    register={register}
                    errors={errors}
                    fieldType="file"
                    onChange={(e) => setImageFile(e.target.files[0])}
                    accept="image/*"
                    placeholder={fieldTitle}
                  />
                </div>
              </Grid>
            ))}

            {/* Submit & Cancel Buttons */}
            <Grid item xs={12} lg={4} className="flex justify-end gap-2">
              <Button variant="contained" color="error" onClick={onCancel}>
                Cancel
              </Button>
              <Button
                variant="contained"
                // color="primary"
                type="submit"
                className="bg-blueBg hover:bg-blueBg"
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
    </>
  );
};

export default AddImage;
